import { render } from "./Header.vue?vue&type=template&id=b2fb97e0&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=b2fb97e0&scoped=true&lang=css"

import exportComponent from "D:\\hemiao100Code\\hemiao100-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fb97e0"]])

export default __exports__